import { take, put, all } from 'redux-saga/effects';
import uuid from 'uuid/v4';

import log from 'yeself-client-common/utils/LogUtils';

import { pushNotificationToStack } from 'Console/data/notification/actions';

import {
    fetchSegmentsSuccess,
    fetchSegmentError,
    createNewSegmentSuccess,
    onCrateNewSegmentError,
    editSegmentSuccess,
    editSegmentError,
} from './actions';
import { FETCH_SEGMENT_LIST, CREATE_NEW_SEGMENT, EDIT_SEGMENT } from './constants';

const createSegment = (name, kind, valueType, description, active, systemKey) => ({
    id: uuid(),
    name,
    kind,
    valueType,
    description,
    active,
    systemKey,
});

const segments = [
    createSegment('IP Address', 'System Collected', 'Keyword', 'ladislav@yeself.com', 'No', 'actddd'),
    createSegment('Devise type', 'System Collected', 'Keyword', 'tomas@yeself.com', 'Yes', 'actdd1'),
    createSegment('Release date', 'User Collected', 'Date', 'majka@yeself.com', 'No', 'actddd2'),
    createSegment('App version', 'User Collected', 'Keyword', 'peter@yeself.com', 'Yes', 'actddd3'),
    createSegment('Test group', 'User Collected', 'Integer', 'palci@yeself.com', 'Yes', 'actddd4'),
    createSegment('Test group2', 'User Frontend', 'Integer', 'palci@yeself.com', 'Yes', 'actdd5'),
];

function* fetchSegmentWatcher() {
    while (true) {
        yield take(FETCH_SEGMENT_LIST);

        try {
            // const res = yield call(fetchSegmentsService);

            yield put(fetchSegmentsSuccess(segments));
        } catch (err) {
            log.error(err);
            yield put(fetchSegmentError());
        }
    }
}

function* createNewSegmentWatcher() {
    while (true) {
        const { payload, message } = yield take(CREATE_NEW_SEGMENT);

        try {
            const newSegmentData = {
                id: uuid(),
                name: payload.name,
                kind: payload.kind,
                valueType: payload.valueTypes,
                description: payload.description,
                active: true ? 'Yes' : 'No',
                systemKey: payload.systemKey,
            };
            // const resp = yield call(createNewApplicationRequest, newSegmentData);
            // yield put(fetchSegment(resp.body));
            yield put(createNewSegmentSuccess(newSegmentData));
            yield put(pushNotificationToStack(message.success));
        } catch (err) {
            log.error(err);
            yield put(onCrateNewSegmentError());
            yield put(pushNotificationToStack(message.fail));
        }
    }
}

function* editSegmentWatcher() {
    while (true) {
        const {
            payload: { originalSegment, newData },
            message,
        } = yield take(EDIT_SEGMENT);

        try {
            const updatedSegment = {
                id: originalSegment.id,
                name: newData.name ? newData.name : originalSegment.name,
                kind: newData.kind ? newData.kind : originalSegment.kind,
                valueType: newData.valueType ? newData.valueType : originalSegment.valueType,
                description: newData.description ? newData.description : originalSegment.description,
                active: newData.active ? 'Yes' : 'No',
                systemKey: newData.systemKey ? newData.systemKey : originalSegment.systemKey,
            };

            // const resp = yield call(createNewApplicationRequest, newSegmentData);
            // yield put(fetchSegment(resp.body));
            yield put(editSegmentSuccess(updatedSegment));
            yield put(pushNotificationToStack(message.success));
        } catch (err) {
            log.error(err);
            yield put(editSegmentError());
            yield put(pushNotificationToStack(message.fail));
        }
    }
}

export default function* segmentsSaga() {
    yield all([fetchSegmentWatcher(), createNewSegmentWatcher(), editSegmentWatcher()]);
}
